import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate } from 'react-router';
// import history from '../../history';
import Modal from 'react-modal';
import {Translate, I18n} from 'react-redux-i18n';

import Loading from '../../components/Loading/Loading';
import style from './ExerciseRun.module.css';

import Dashboard from './Dashboard';
import Preview from './Preview';
import CommunicationBox from './CommunicationBox';
import Variables from './Variables';
import PerformanceMonitor from '../../components/PerformanceMonitor/PerformanceMonitor';

// import SUSRenderer from 'susjs-renderer';

import {
  end as endAction,
  showHideVariables as showHideVariablesAction,
} from './ExerciseRunActions';

import PreviewBenchmarkDrawer from '../ExerciseBenchmark/PreviewDrawer';
import {
    openPreviewDialog
} from '../ExerciseBenchmark/ExerciseBenchmarkActions';

export default function Exercises({ id: propId }) {
  const loading = useSelector(state => state.exercise.loading);
  const exercise = useSelector(state => state.exercise.exercise);
  const playCurTime = useSelector(state => state.exercise.playCurTime);
  const showVariables = useSelector(state => state.exerciseRun.showVariables);
  const currentBenchmarks = useSelector(state => state.exerciseBenchmark.currentBenchmarks);
  const isPreviewBenchmarkDialogOpen = useSelector(state => state.exerciseBenchmark.isPreviewBenchmarkDialogOpen);

  const dispatch = useDispatch();

  const { id: paramId } = useParams();
  const id = propId || paramId;
  const navigate = useNavigate();

  function playStart() {
    global.socket.emit('play_start');
  }

  function playPause() {
    global.socket.emit('play_pause');
  }

  function playStop() {
    if (confirm(I18n.t('exerciseRun.timeResetConfirm'))) {
      global.socket.emit('play_stop');
    }
  }

  // Back function unused in render but was in class component
  // function back() {
  //   navigate('/exercises');
  // }

  function handleEnd() {
    if (confirm(I18n.t('exerciseRun.endExerciseConfirm'))) {
      dispatch(endAction(id));
      navigate('/exercises');
    }
  }

  const {name, code} = exercise;

  const scenarioName = exercise.scenario.title;

  const printPlayTime = (playtime) => {
    let hrs = Math.floor(playtime / 60 / 60 / 1000);
    let mins = Math.floor(playtime / 60 / 1000) - hrs * 60;
    let secs = Math.floor(playtime / 1000) - mins * 60 - hrs * 60 * 60;

    let format = val => ("0" + val).slice(-2);
    return format(hrs) + ':' + format(mins) + ':' + format(secs);
  };

  return (
    <div className="row">
    
      <PreviewBenchmarkDrawer answerable />
      
      <div className="col-md-12 mt-4">
        { loading && <Loading /> }
        <Translate value="exerciseRun.desc"/>

        <div id="sim"></div>
        <div className={style.groupButtons}>
          <strong className={style.time}>{printPlayTime(playCurTime)}</strong>

          <button
            type="button"
            className={`btn btn-default ${style.roundButton}`}
            onClick={playStop}
            disabled={ !exercise.playStartedAt && playCurTime === 0 }
          >
            <i className="fas fa-fast-backward fa-fw"/>
          </button>
          <button
            type="button"
            className={`btn btn-default ${style.roundButton}`}
            onClick={playStart}
            disabled={ exercise.playStartedAt }
          >
            <i className="fas fa-play fa-fw"/>
          </button>
          <button
            type="button"
            className={`btn btn-default ${style.roundButton}`}
            onClick={playPause}
            disabled={ !exercise.playStartedAt }
          >
            <i className="fas fa-pause fa-fw"/>
          </button>
          <div className={style.backButtons}>
            {
              !!currentBenchmarks.length &&
              <button
                className={"btn btn-primary"}
                onClick={() => dispatch(openPreviewDialog())}
              >
                <Translate value="exercise.Benchmark" />
                <i className="fas fa-clipboard-list" style={{marginLeft: 4}} />
              </button>
            }
            <button
              type="button"
              onClick={() => dispatch(showHideVariablesAction(true))}
              className="btn btn-primary"
            >
              <Translate value="exerciseRun.Variables"/>
            </button>
            {/*<button*/}
              {/*type="button"*/}
              {/*onClick={back}*/}
              {/*className="btn btn-default"*/}
            {/*><i className="fas fa-mail-reply"/> Return to exercises*/}
            {/*</button>*/}
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleEnd}
            ><i className="fas fa-times"/>
              &nbsp;
              <Translate value="exerciseRun.EndExercise"/>
            </button>
          </div>
        </div>
        <hr className={style.timeHr}/>
        <div className={style.contentContainer} style={isPreviewBenchmarkDialogOpen? {width: "50%"} : {}}>
          <h4><strong>
            <PerformanceMonitor />
            <Translate value="exerciseRun.ScenarioInfo" exerciseCode = { code } scenarioName={ scenarioName } exerciseName={ name }/>
          </strong></h4>
          <Dashboard />
        </div>
        <div className={`${style.contentContainer} ${style.innerContainer}`}>
          <CommunicationBox />
        </div>
        <div className={style.contentContainer}>
          <Preview />
        </div>
        <Modal
          isOpen={showVariables}
          contentLabel="variables"
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              maxHeight: '90vh',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
            },
          }}
        >
          <Variables />
        </Modal>
      </div>
    </div>
  );
}

